import { IconConfig } from "../types";

export const garage: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 55 57",
  elements: [
    {
      type: 'g',
      children: [
        {
          type: 'path',
          d: "M54.399 16.189 27.893.137a.94.94 0 0 0-.976 0L.428 16.189a.92.92 0 0 0-.427.812v39.208a.924.924 0 0 0 .895.972h5.652a.95.95 0 0 0 .929-.972V29.291h39.876v26.918a.95.95 0 0 0 .929.972h5.653a.924.924 0 0 0 .895-.972V17.002a.93.93 0 0 0-.431-.813m-46.922 11.2v-3.8h39.876v3.8Zm45.454 27.89h-3.679V22.654a.974.974 0 0 0-.969-.958H6.548a.974.974 0 0 0-.969.958v32.628h-3.68V17.537L27.415 2.059l25.516 15.478Z"
        },
        {
          type: 'path',
          d: "m42.164 39.959-2.509-6.79a3.215 3.215 0 0 0-2.987-2.1H18.611a3.22 3.22 0 0 0-2.987 2.1l-2.474 6.687-.975.919a4.3 4.3 0 0 0-1.492 3.271v12.162a.954.954 0 0 0 .932.972h6.336a.946.946 0 0 0 .921-.972v-3.419h17.09v3.419a.946.946 0 0 0 .921.972h6.336a.954.954 0 0 0 .932-.972V43.79a4.31 4.31 0 0 0-1.317-3.107Zm-24.759-6.111a1.33 1.33 0 0 1 1.207-.878h18.056a1.33 1.33 0 0 1 1.207.878l2.079 5.649H15.326Zm-.433 21.433h-4.389v-2.492h4.391Zm20.887 0v-2.492h4.391v2.492Zm4.391-4.391H12.583v-6.844a2.4 2.4 0 0 1 .84-1.834c.011-.009.017 0 .028-.009l.886-.808h26.535l.6.624c.013.014.018.018.033.032a2.38 2.38 0 0 1 .745 1.738Z"
        },
        {
          type: 'path',
          d: "M17.267 43.651h-.548a2.789 2.789 0 0 0 0 5.578h.548a2.789 2.789 0 0 0 0-5.578m0 3.679h-.548a.89.89 0 0 1 0-1.78h.548a.89.89 0 0 1 0 1.78"
        },
        {
          type: 'path',
          d: "M38.112 43.651h-.55a2.789 2.789 0 0 0 0 5.578h.548a2.789 2.789 0 0 0 0-5.578Zm0 3.679h-.55a.89.89 0 0 1 0-1.78h.548a.89.89 0 0 1 0 1.78Z"
        },
        {
          type: 'path',
          d: "M33.112 44.719a.95.95 0 0 0-.949-.949H22.55a.95.95 0 0 0-.949.949v3.56a.95.95 0 0 0 .949.949h9.613a.95.95 0 0 0 .949-.949Zm-1.78 2.611H23.5v-1.66h7.833Z"
        }
      ]
    }
  ]
}
